/**
 * 受控访问：入口页密令验证后写入的令牌 Cookie。
 * 中间件、服务端动作与全局布局共用这里的定义，避免各处写死字符串后失配。
 */

/** 存放访问令牌的 Cookie 名称 */
export const ACCESS_COOKIE = "fp_access";

/** 通过验证后写入的令牌值 */
export const ACCESS_VALUE = "granted";

/** 入口页（未验证时唯一的可达页面） */
export const LANDMARK_PATH = "/";

/** 验证通过后的默认落地页 */
export const DEFAULT_ENTRY = "/home";

/** 需要密令验证后才可访问的路径前缀 */
export const PROTECTED_PREFIXES = ["/home", "/data", "/principles", "/clauses", "/planning"] as const;

/** 只接受站内以单个斜杠开头的相对路径，避免跳转到外部地址 */
export function safeInternalPath(candidate: string | null | undefined): string | null {
  if (!candidate || !candidate.startsWith("/") || candidate.startsWith("//")) return null;
  return candidate;
}
